export const SIDEBAR_WIDTH = 280
export const COLLAPSED_WIDTH = 48
export const ANIMATION_DURATION_MS = 250
export const BACKDROP_BLUR = '8px'
export const BACKDROP_OPACITY = 0.5
export const SIDEBAR_Z_INDEX = 1100
export const BACKDROP_Z_INDEX = 1050

export const LOCAL_STORAGE_KEY = 'sidebar-pinned'
